import { render, staticRenderFns } from "./OverseaServiceInfo.vue?vue&type=template&id=05d7c800&scoped=true"
import script from "./OverseaServiceInfo.vue?vue&type=script&lang=js"
export * from "./OverseaServiceInfo.vue?vue&type=script&lang=js"
import style0 from "./OverseaServiceInfo.vue?vue&type=style&index=0&id=05d7c800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7c800",
  null
  
)

export default component.exports